var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",attrs:{"id":"MainFooter"}},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('strong',{staticStyle:{"color":"#6c6c6c"}},[_vm._v("NiXT Platform")]),_vm._v(" "),_c('br'),_vm._v(" © Copyright 2021 Banpu NEXT Co., Ltd. ")])])])
}]

export { render, staticRenderFns }